<template>
  <div id="kt_header" ref="kt_header" class="kt-header kt-grid__item">
    <b-row class="w-100">
      <b-col></b-col>
      <b-col><slot></slot></b-col>
      <b-col></b-col>
    </b-row>
  </div>
</template>

<script>
import HtmlClass from "@/common/htmlclass.service";

export default {
  name: "PPHeader",
  beforeMount() {
    HtmlClass.initSkins();
  }
};
</script>
